import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuthStore } from '../../store/authStore';
import { useCompanyInfo } from '../../pages/verve-settings/hooks/useCompanyInfo';
import {
  Home,
  LayoutDashboard,
  FileText,
  Users,
  Settings,
  Target,
  Layers,
  Package,
  IndianRupee,
  ChevronDown,
  PanelLeftClose,
  PanelLeftOpen,
  Bell,
  PenTool,
  CheckSquare,
  Compass,
  MessageCircle,
  Share2,
  Wrench,
  Headphones,
  Briefcase,
  CalendarDays,
  CreditCard,
} from 'lucide-react';

/*developer: Nithin
    date : 2024-06-19
    changes : Replaced Telecaller With Staff  And added general expenses */
const navItems = [
  { label: 'Home', path: '/home', icon: <Home size={16} />, roles: ['admin', 'owner', 'designer', 'senior_designer', 'accountant', 'installation_team', 'client_coordinator', 'store_incharge', 'sales_executive', 'field_marketing', 'social_media'] },
  { label: 'Dashboard', path: '/', icon: <LayoutDashboard size={16} />, roles: ['admin', 'owner', 'installation_team'] },
  { label: 'Clients', path: '/contacts', icon: <Users size={16} />, roles: ['admin', 'owner', 'installation_team', 'client_coordinator', 'site-executive', 'field_marketing', 'sales_executive', 'designer', 'senior_designer', 'social_media', 'accountant'] },
  // { label: 'Leads', path: '/leads', icon: <Target size={16} />, roles: ['admin', 'owner', 'designer', 'senior_designer', 'installation_team', 'sales_executive', 'field_marketing'] },
  { label: 'Quotations & orders', path: '/budget', icon: <IndianRupee size={16} />, roles: ['admin', 'owner', 'accountant', 'client_coordinator', 'field_marketing', 'senior_designer'] },
  { label: 'Lead Executions', path: '/lead-executions', icon: <Layers size={16} />, roles: ['admin', 'owner', 'designer', 'senior_designer', 'installation_team', 'client_coordinator'] },
  // { label: 'Projects', path: '/projects', icon: <Layers size={16} />, roles: ['admin', 'owner', 'designer', 'senior_designer', 'installation_team'] },
  { label: 'Inventory', path: '/inventory', icon: <Package size={16} />, roles: ['admin', 'owner', 'installation_team', 'store_incharge', 'accountant'] },
  {
    label: 'Stock Table',
    path: '/stock',
    icon: <Package size={16} />,
    roles: ['admin', 'owner', 'store_incharge']
  },
  // { label: 'Ordering', path: '/ordering', icon: <Package size={16} />, roles: ['admin', 'owner', 'store_incharge', 'client_coordinator'] },
  // Added Catalog item below Ordering as requested
  // { label: 'Catalog', path: '/catalog', icon: <FileText size={16} />, roles: ['admin', 'owner', 'store_incharge', 'designer', 'senior_designer'] },
  { label: 'Accounts', path: '/accounts', icon: <IndianRupee size={16} />, roles: ['admin', 'owner', 'accountant', 'installation_team', 'senior_designer'] },
  { label: 'General Expenses', path: '/accounts?tab=general_expenses', icon: <IndianRupee size={16} />, roles: ['admin', 'owner', 'designer', 'senior_designer', 'accountant', 'installation_team', 'client_coordinator', 'store_incharge', 'sales_executive', 'field_marketing', 'social_media'] },
  // { label: 'Design', path: '/projects?tab=design', icon: <PenTool size={16} />, roles: ['designer', 'senior_designer'] },
  // { label: 'AutoCAD', path: '/autocad', icon: <Compass size={16} />, roles: ['designer', 'senior_designer', 'owner'] },
  { label: 'Documents', path: '/documents', icon: <FileText size={16} />, roles: ['admin', 'owner', 'designer', 'senior_designer', 'accountant', 'installation_team', 'site-executive', 'field_marketing', 'store_incharge', 'sales_executive', 'client_coordinator', 'social_media'] },
  // Developer: Nithin | Date: 2026-07-26 | Added accountant role to Attendance Tracker
  { label: 'Attendance Tracker', path: '/attendance-tracker', icon: <CalendarDays size={16} />, roles: ['admin', 'owner', 'accountant'] },
  { label: 'Approvals', path: '/approvals', icon: <CheckSquare size={16} />, roles: ['admin', 'owner'] },
  { label: 'Social Media', path: '/social-media', icon: <Share2 size={16} />, roles: ['admin', 'owner', 'designer', 'senior_designer', 'sales_executive', 'field_marketing', 'social_media'] },
  { label: 'WhatsApp', path: '/whatsapp', icon: <MessageCircle size={16} />, roles: ['admin', 'owner', 'designer', 'senior_designer', 'accountant', 'installation_team', 'client_coordinator', 'store_incharge', 'sales_executive', 'field_marketing', 'social_media'] },

  { label: 'Notifications', path: '/notifications', icon: <Bell size={16} />, roles: ['admin', 'owner', 'designer', 'senior_designer', 'accountant', 'installation_team', 'client_coordinator', 'store_incharge', 'sales_executive', 'field_marketing', 'social_media'] },
  { label: 'Team', path: '/users', icon: <Users size={16} />, roles: ['admin', 'owner'] },
  { label: 'Technical Support', path: '/technical-support', icon: <Wrench size={16} />, roles: ['admin', 'owner', 'designer', 'senior_designer', 'accountant', 'installation_team', 'client_coordinator', 'store_incharge', 'sales_executive', 'field_marketing', 'social_media'] },
  { label: 'Customer Support', path: '/customer-support', icon: <Headphones size={16} />, roles: ['admin', 'owner', 'designer', 'senior_designer', 'accountant', 'installation_team', 'client_coordinator', 'store_incharge', 'sales_executive', 'field_marketing', 'social_media'] },

  // HR Module
  { label: 'HR Dashboard', path: '/hr/dashboard', icon: <LayoutDashboard size={16} />, roles: ['owner', 'hr', 'accountant'] },
  { label: 'Employee Onboarding', path: '/hr/onboarding', icon: <Users size={16} />, roles: ['owner', 'hr', 'accountant'] },
  { label: 'Attendance', path: '/hr/attendance', icon: <CalendarDays size={16} />, roles: ['owner', 'hr', 'accountant'] },
  { label: 'Leaves', path: '/hr/leaves', icon: <FileText size={16} />, roles: ['owner', 'hr', 'accountant'] },
  { label: 'Pay Setup', path: '/hr/pay-setup', icon: <IndianRupee size={16} />, roles: ['owner', 'hr', 'accountant'] },
  { label: 'Payslips', path: '/hr/payslips', icon: <CreditCard size={16} />, roles: ['owner', 'hr', 'accountant'] },

  { label: 'Settings', path: '/settings', icon: <Settings size={16} />, roles: ['admin', 'owner'] },
];

export const Sidebar = ({ collapsed, onToggle }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user, logout } = useAuthStore();
  const { company } = useCompanyInfo();
  const dropdownItems = ['Clients', 'Leads', 'Lead Executions', 'Quotations & orders', 'Projects', 'Inventory', 'Ordering', 'Catalog', 'Accounts', 'General Expenses', 'Design', 'AutoCAD', 'Documents', 'Attendance Tracker'];
  const hrDropdownItems = ['HR Dashboard', 'Employee Onboarding', 'Attendance', 'Leaves', 'Pay Setup', 'Payslips'];

  /* Developer : Nithin
  Date : 26-06-2026
  changes: added checkIsActive to prevent overlapping highlights for specific query matches */
  const checkIsActive = (item) => {
    const fullLocation = location.pathname + location.search;
    if (item.path.includes('?')) {
      return fullLocation === item.path;
    }
    const hasSpecificMatch = navItems.some(i => i.path === fullLocation && i.path !== item.path);
    return (location.pathname === item.path || (item.path !== '/' && location.pathname.startsWith(item.path) && !item.path.includes('?'))) && !hasSpecificMatch;
  };

  const isInsideDropdown = () => {
    return navItems.some(item => checkIsActive(item) && dropdownItems.includes(item.label));
  };

  const isInsideHrDropdown = () => {
    return navItems.some(item => checkIsActive(item) && hrDropdownItems.includes(item.label));
  };

  const [isVerveOpen, setIsVerveOpen] = useState(isInsideDropdown());
  const [isHrOpen, setIsHrOpen] = useState(isInsideHrDropdown());
  const [logoError, setLogoError] = useState(false);

  useEffect(() => {
    setIsVerveOpen(isInsideDropdown());
    setIsHrOpen(isInsideHrDropdown());
  }, [location.pathname, location.search]);

  useEffect(() => {
    setLogoError(false);
  }, [company?.logoUrl]);

  const filteredNav = navItems.filter(item => user && item.roles.includes(user.role));

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const NavLink = ({ item, indent = false }) => {
    const isActive = checkIsActive(item);

    return (
      <Link
        to={item.path}
        title={item.label}
        onClick={() => {
          if (item.path === '/budget') {
            window.dispatchEvent(new CustomEvent('reset-budget-tab'));
          }
          const localDropdownItems = ['Clients', 'Leads', 'Lead Executions', 'Quotations & orders', 'Projects', 'Inventory', 'Ordering', 'Catalog', 'Accounts', 'General Expenses', 'Design', 'AutoCAD', 'Documents', 'Attendance Tracker'];
          if (!localDropdownItems.includes(item.label)) {
            setIsVerveOpen(false);
          }
        }}
        //updated Halimunnisa 09-06-2024
        className={`relative flex items-center gap-3 rounded-lg text-sm font-medium transition-all duration-150 border group
          ${collapsed ? 'justify-center px-0 py-3' : `px-3 py-2.5 ${indent ? 'ml-6' : ''}`}
          ${isActive
            ? 'bg-slate-100 text-slate-900 font-semibold border-slate-200 shadow-sm'
            : 'text-slate-600 hover:bg-slate-200/50 hover:text-slate-800 border-transparent'
          }`}
      >
        <span className="shrink-0">{item.icon}</span>
        {!collapsed && <span>{item.label}</span>}
        {/* Tooltip on collapsed */}
        {collapsed && (
          <span className="absolute left-full ml-3 px-2.5 py-1.5 bg-white text-slate-900 text-xs font-medium rounded-md whitespace-nowrap opacity-0 group-hover:opacity-100 pointer-events-none transition-opacity duration-150 z-50 shadow-xl border border-slate-200">
            {item.label}
          </span>
        )}
      </Link>
    );
  };

  return (
    <aside
      className={`fixed left-0 top-0 h-screen bg-slate-50 border-r border-slate-200 flex flex-col transition-all duration-300 z-40 ${collapsed ? 'w-[60px]' : 'w-60'}`}
    >
      {/* Logo Area */}
      <div className={`relative flex items-center h-[72px] px-3 flex-shrink-0 ${collapsed ? 'flex-col justify-center gap-2' : 'justify-center'}`}>
        <img
          key={company?.logoUrl || 'default-logo'}
          src={(!logoError && company?.logoUrl) ? company.logoUrl : "/verve-kitchens-logo-01.png"}
          alt={company?.name || "Verve Kitchens"}
          className={`object-contain transition-all duration-300 ${collapsed ? 'h-10 w-10' : 'h-[64px]'}`}
          style={(!logoError && company?.logoUrl) ? { maxWidth: collapsed ? '40px' : '200px' } : { filter: 'brightness(0)' }}
          onError={() => setLogoError(true)}
        />
        <div className={collapsed ? "" : "absolute right-3"}>
          {collapsed ? (
            <button
              onClick={onToggle}
              className="p-1 rounded-lg text-slate-400 hover:text-slate-900 hover:bg-slate-200 transition-all duration-150"
              title="Expand sidebar"
            >
              <PanelLeftOpen size={16} />
            </button>
          ) : (
            <button
              onClick={onToggle}
              className="p-1.5 rounded-lg text-slate-500 hover:text-slate-900 hover:bg-slate-200 transition-all duration-150"
              title="Collapse sidebar"
            >
              <PanelLeftClose size={16} />
            </button>
          )}
        </div>
      </div>

      {/* Divider */}
      <div className="mx-3 mb-1"><div className="h-[1px] bg-slate-200 rounded-full" /></div>

      {/* Navigation */}
      <nav className="flex-1 overflow-y-auto overflow-x-hidden py-2 px-2 space-y-0.5">

        {/* Top: Home, Dashboard */}
        {filteredNav
          .filter(item => ['Home', 'Dashboard'].includes(item.label))
          .map(item => <NavLink key={item.path} item={item} />)}

        {/* Section separator / heading */}
        {!collapsed ? (
          <button
            onClick={() => setIsVerveOpen(!isVerveOpen)}
            className={`w-full flex items-center justify-between px-3 py-2 mt-3 mb-1 rounded-lg transition-all duration-200 border ${isInsideDropdown()
              ? 'bg-slate-500 text-white border-slate-500 shadow-sm'
              : 'hover:bg-slate-200/50 text-slate-600 hover:text-slate-800 border-transparent'
              }`}
          >
            <div className="flex items-center gap-2">
              <div className="w-5 h-5 rounded-md flex items-center justify-center">
                <Layers size={16} className={isInsideDropdown() ? "text-white" : "text-slate-600"} />
              </div>
              <span className={`text-sm font-medium ${isInsideDropdown() ? "text-white" : "text-slate-600"}`}>
                Verve Kitchens
              </span>
            </div>
            <ChevronDown
              size={13}
              className={`${isInsideDropdown() ? 'text-white' : 'text-slate-500'} transition-transform duration-200 ${isVerveOpen ? 'rotate-180' : ''}`}
            />
          </button>
        ) : (
          <div className="my-2"><div className="h-[1px] bg-slate-200 rounded-full mx-1" /></div>
        )}

        {/* Main items */}
        {(collapsed || isVerveOpen) && filteredNav
          .filter(item => ['Clients', 'Leads', 'Lead Executions', 'Quotations & orders', 'Projects', 'Inventory', 'Ordering', 'Catalog', 'Accounts', 'General Expenses', 'Design', 'AutoCAD', 'Documents', 'Attendance Tracker'].includes(item.label))
          .map(item => <NavLink key={item.path} item={item} indent={!collapsed} />)}

        {/* Items immediately below Verve Kitchens */}
        {filteredNav
          .filter(item => ['WhatsApp', 'Approvals'].includes(item.label))
          .map(item => <NavLink key={item.path} item={item} />)}

        {/* Divider before Team/Settings */}
        {/* <div className="my-2"><div className="h-[1px] bg-slate-200 rounded-full mx-1" /></div> */}

        {/* Bottom: Team, Support, Notifications, Social Media */}
        {filteredNav
          .filter(item => ['Social Media', 'Notifications', 'Team', 'Technical Support', 'Customer Support'].includes(item.label))
          .map(item => <NavLink key={item.path} item={item} />)}

        {/* HR Module Dropdown */}
        {filteredNav.some(item => hrDropdownItems.includes(item.label)) && (!collapsed ? (
          <button
            onClick={() => setIsHrOpen(!isHrOpen)}
            className={`w-full flex items-center justify-between px-3 py-2 mt-3 mb-1 rounded-lg transition-all duration-200 border ${isInsideHrDropdown()
              ? 'bg-slate-500 text-white border-slate-500 shadow-sm'
              : 'hover:bg-slate-200/50 text-slate-600 hover:text-slate-800 border-transparent'
              }`}
          >
            <div className="flex items-center gap-2">
              <div className="w-5 h-5 rounded-md flex items-center justify-center">
                <Briefcase size={16} className={isInsideHrDropdown() ? "text-white" : "text-slate-600"} />
              </div>
              <span className={`text-sm font-medium ${isInsideHrDropdown() ? "text-white" : "text-slate-600"}`}>
                Human Resources
              </span>
            </div>
            <ChevronDown
              size={13}
              className={`${isInsideHrDropdown() ? 'text-white' : 'text-slate-500'} transition-transform duration-200 ${isHrOpen ? 'rotate-180' : ''}`}
            />
          </button>
        ) : (
          <div className="my-2"><div className="h-[1px] bg-slate-200 rounded-full mx-1" /></div>
        ))}

        {/* HR Child Items */}
        {(collapsed || isHrOpen) && filteredNav
          .filter(item => hrDropdownItems.includes(item.label))
          .map(item => <NavLink key={item.path} item={item} indent={!collapsed} />)}

        {/* Settings at the very bottom */}
        {filteredNav
          .filter(item => ['Settings'].includes(item.label))
          .map(item => <NavLink key={item.path} item={item} />)}
      </nav>

      {/* Divider */}
      <div className="mx-3 mt-1"><div className="h-[1px] bg-slate-200 rounded-full" /></div>

      {/* User profile */}
      <div className={`p-3 bg-slate-100 flex-shrink-0 ${collapsed ? 'flex flex-col items-center gap-2' : 'flex items-center gap-3'}`}>

        {/* Avatar */}
        <div className="w-8 h-8 bg-gradient-to-br from-amber-500 to-orange-400 rounded-full flex items-center justify-center flex-shrink-0 shadow-sm">
          <span className="text-white text-sm font-bold">{user?.name?.charAt(0)}</span>
        </div>

        {!collapsed && (
          <>
            <div className="flex-1 min-w-0">
              <div className="text-xs font-semibold text-slate-900 truncate">{user?.name}</div>
              <div className="text-[11px] text-slate-500 truncate capitalize">{user?.role?.replace(/_/g, ' ')}</div>
            </div>
            <button onClick={handleLogout} className="text-slate-500 hover:text-red-600 transition-colors flex-shrink-0" title="Logout">
              <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
              </svg>
            </button>
          </>
        )}

        {collapsed && (
          <button onClick={handleLogout} className="text-slate-500 hover:text-red-600 transition-colors" title="Logout">
            <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <path d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
            </svg>
          </button>
        )}
      </div>
    </aside>
  );
};
